import { useMemo } from "react"
import { Outlet } from "react-router-dom"
import { useAccountAspect } from "@oysterhr/identity/AccountAspectContext"
import { MissingPage } from "~/shared/pages/system"
import { usePaymentCompanyPaymentMethods } from "~/app/queries/usePaymentCompanyPaymentMethods"
import { CompanyCurrencyEnumType } from "@oysterhr/schema"

export const PaymentMethodsProtectedRoute = ({
  rules,
}: {
  rules: {
    companyPaymentCurrencyCode: CompanyCurrencyEnumType[]
    companyDoesNotHavePaymentMethod?: boolean
  }
}) => {
  const { accountAspect } = useAccountAspect()
  const { data, loading } = usePaymentCompanyPaymentMethods(accountAspect)
  const company = data?.company

  const shouldShowPage = useMemo(() => {
    if (!company) return false

    const companyRules: Record<string, CompanyCurrencyEnumType | boolean> = {
      companyPaymentCurrencyCode: company.paymentCurrencyCode as CompanyCurrencyEnumType,
      companyDoesNotHavePaymentMethod: !company.paymentMethod,
    }

    return Object.entries(rules).every(([key, value]) => {
      // if the rule being processed is companyDoesNotHavePaymentMethod rule
      // we don't want to show the page if company has payment method
      if (typeof value === "boolean") {
        return companyRules[key] === value
      }

      // otherwise the value is an array of allowed company currencies
      return value.some(item => companyRules[key] === item)
    })
  }, [rules, company])

  if (loading) return null

  return shouldShowPage ? <Outlet /> : <MissingPage />
}
